export default __webpack_public_path__ + "static/media/Amar_Akber_Anthony_Bg.ac0155c2.webp";